import React from "react";

class InProgressPopup extends React.Component {
    constructor(props) {
        super(props)
        this.state ={}
    }

    componentDidMount() {
        window.addEventListener('click', this.closeOnOutClick)
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.closeOnOutClick)
    }

    closeOnOutClick = (e) => {        
        if (e.target.id == 'inProgressPopupWrapper') {
            this.props.close()
        }
    }


    render() {
        let { inProgressData, visible, close } = this.props
        
        return visible ? (
            <div style={{ ...styles.wrapper }} id={"inProgressPopupWrapper"}>
                <div style={{ ...styles.container }}>
                    <button onClick={close} style={{ ...styles.close }}>+</button>
                    {/* <span style={{ ...styles.title }}>{"תוכן"}</span> */}
                    <div style={{ ...styles.textBox }}>
                        <pre style={{ ...styles.pre }}>
                            {inProgressData ? JSON.stringify(JSON.parse(inProgressData), null, 2) : ''}
                        </pre>
                    </div>
                </div>
            </div>
        ) : ''
    }
}


const styles = {
    wrapper: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        background: '#D3D5D679',
        top: 0,
        left: 0
    },
    container : {
        width: '460px',
        // minHeight: '250px',
        height: 'auto',
        borderRadius: '16px',
        background: 'white',
        border: 'solid #e3e3e3 1px',
        marginTop: '-160px',
        padding: '10px'
    },
    close: {
        padding: '0',
        background: 'none',
        border: 'none',
        rotate: '45deg',
        fontSize: '30px',
        position: 'relative',
        cursor: 'pointer'
    },
    title: {},
    textBox: {
        minHeight: '150px',
        maxHeight: '300px',
        overflowY: 'auto',
        borderRadius: '6px',
        border: 'solid #e3e3e3 1px',
        margin: '0 25px 10px'
    },
    pre: {
        direction: 'ltr',
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    }
}


export default InProgressPopup